import { NotificationImportantOutlined } from '@mui/icons-material';
import { Button, SnackbarContent } from '@mui/material';
import styled from 'styled-components';

import { background, primaryBlue, primaryRed } from '../models/colors';

export const Alert = styled(({ message, action, ...rest }: any) => (
	<SnackbarContent
		{...rest}
		message={
			<span style={{ display: 'flex', alignItems: 'center' }}>
				<NotificationImportantOutlined style={{ padding: '8px' }} />
				<span>{message}</span>
			</span>
		}
		action={action}
	/>
))`
  max-width: none;
  font-weight: bold;
  border-radius: 4px;
  color: ${primaryRed};
  justify-content: center;
  background-color: ${background};
  border: 2px solid ${primaryRed};
  & + & {
    margin-top: 16px;
  }
`;

export const AlertButton = styled(({ label, icon, ...rest }: any) => (
	<Button variant={`text`} {...rest}>
		{icon ? icon : null}
		{label}
	</Button>
))`
  padding: 4px;
  font-weight: bold;
  font-size: 0.8125rem;
  text-transform: none;
  color: ${primaryBlue};
  &:hover {
    text-decoration: underline;
  }
`;
